export const userAvailableSessionsFields = `
  active_plus_end_date
  available_sessions
  personalized_sessions
  is_active_plus
`;

export const userMembershipFields = `
  active_plus_end_date
  available_sessions
  personalized_sessions
  is_active_plus
  membership_status
  membership_days_left
  photo
  # Se refresca en cada montaje del layout: si el admin nombra (o retira) a alguien como
  # contacto de su empresa, no tiene que cerrar sesión para que cambie su panel.
  is_org_manager
  # El sidebar del contacto de bienestar muestra el nombre de su empresa en lugar de su
  # membresía, que ahí no significa nada.
  organization {
    id
    name
    # is_default es imprescindible: la organización por defecto ("OTRIX App") es el cajón donde
    # cae todo el que no pertenece a una empresa real, así que su marca NO se puede pintar.
    is_default
    cover_url
    logo_url
  }
`;

export const userAvatarFields = `
  id
  first_name
  full_name
  last_name
`;

export const userAvatarWithSpecialtiesFields = `
  id
  first_name
  full_name
  last_name
  photo
  specialties {
    id
  }
`;

export const userLoginFields = `
  id
  academic_formation
  age
  active_plus_end_date
  active_plus_days_left
  active_plans {
    id
    name
    type
    platform
    price
    price_usd
    price_cop
    sessions
  }
  available_sessions
  personalized_sessions
  bank
  bank_account_certificate
  bank_account_number
  bank_account_type
  birthdate
  city
  contact_name
  contact_phone
  country
  created_at
  email
  eps
  experience
  first_name
  full_name
  gender
  identification_document
  identification_number
  languages
  last_name
  membership_days_left
  membership_status
  observations
  online_meeting_url
  phone
  photo
  plan_id {
    id
    description
    name
    price
    price_usd
    price_cop
    stripe_price_id
    sessions
  }
  platform
  is_active_plus
  has_one_on_one_sessions
  is_org_manager
  preferred_currency
  profile_complete
  role
  settings {
    id
  }
  specialties {
    id
    name
  }
  state
`;

export const userSearchFields = `
  id
  full_name
`;

export const userUpdateFields = `
  academic_formation
  age
  bank
  bank_account_certificate
  bank_account_number
  bank_account_type
  birthdate
  city
  contact_name
  contact_phone
  country
  email
  eps
  experience
  first_name
  full_name
  gender
  identification_document
  identification_number
  languages
  last_name
  observations
  online_meeting_url
  phone
  photo
  plan_id {
    id
    description
    name
    price
    price_usd
    price_cop
    stripe_price_id
    sessions
  }
  profile_complete
  specialties {
    id
    name
  }
  state
`;
